import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ForgetThanks = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 5000); // 5秒後に遷移

    return () => clearTimeout(timer); // クリーンアップ
  }, [navigate]);

  return (
    <section className="section form-section section-block">
      <div className="tc mb100">
        <p>
          パスワードが変更されました。
          <br />
          新しいパスワードでログインしてください。
          <br />
          <span style={{ fontSize: "0.9em", color: "#666" }}>
            ※5秒後にログインページへ自動で移動します
          </span>
        </p>
      </div>

      <div className="btn-orange mb0">
        <a href="/">ログインページへ</a>
      </div>
    </section>
  );
};

export default ForgetThanks;
